"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.video75 = void 0;
var util_1 = require("./util");
var video75 = function (event) {
    return (0, util_1.videoEvent)(event, "video-75");
};
exports.video75 = video75;
